import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import container from './modules/container.js'
import createLogger from 'vuex/dist/logger';
import * as localData from '@/services/localData.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    container
  },
  strict: debug,
  // plugins: debug? [ createLogger() ] : [],
  state: {
    view_name: localData.getlocalToken('view_name') || '',
    view_role: localData.getlocalToken('view_role') || '',
    notificatioModalVisible: false,
    UI: {
      container_view_selected_tab : 'actions'
    },
    notification: {
      visible: false,
      container: '',
      text: '',
      user: '',
      date: '',
      color: '',
    }
  },
  mutations: {
    set_view_name(state, [view]){
      localData.setlocal('view_name',view)
      state.view_name = view;      
    },
    set_view_role(state, [rol]){
      localData.setlocal('view_role',rol)
      state.view_role = rol
    },
    set_container_view_selected_tab(state, payload){
      state.UI.container_view_selected_tab = payload.tab
    },
    set_notificatioModalVisible(state, boolean){
      state.notificatioModalVisible = boolean
      // console.log(state.notificatioModalVisible)
      // if(!state.notificatioModalVisible){
      //   state.notificatioModalVisible = true
      // }else {
      //   state.notificatioModalVisible = false
     },
    set_notification(state, payload){
      state.notification = payload
    }
  },
  actions: {
    change_container_view_selected_tab(context, newTab){
      context.commit('set_container_view_selected_tab', newTab)
    },
    change_notification(context, notification){
      context.commit('set_notification', notification)
    }
  },
  getters: {
    view_name: state => state.view_name,
    view_role: state => state.view_role,
    notificatioModalVisible: state => state.notificatioModalVisible,
    container_view_selected_tab: state => state.UI.container_view_selected_tab,
    notification: state => state.notification
  }
})